var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',[_c('PortalNavbar')],1),_c('main',[_c('router-view')],1),_c('footer',[_c('PortalFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }